import React from 'react';
import clsx from 'clsx';
import { Card } from 'semantic-ui-react';

const cardWidths = [{ max: 600, items: 1 },
  { max: 950, items: 2 },
  { max: 1300, items: 3 },
  { max: 1650, items: 4 },
  { max: 2000, items: 5 },
  { max: 2350, items: 6 },
  { max: 2700, items: 7 },
  { max: 1000000, items: 8 }];

const ScrollableCards = ({
  children,
  className,
  handleScroll,
  itemsPerRow,
  width,
}) => (
  <Card.Group
    className={clsx('aridhia-responsive-cards', className, handleScroll && 'aridhia-infinite-scroll')}
    itemsPerRow={itemsPerRow || cardWidths.find(({ max }) => width < max).items}
  >
    {children}
  </Card.Group>
);

export default ScrollableCards;
